// extracted by mini-css-extract-plugin
export default {"container":"stats_container__-sckC","inputs":"stats_inputs__qScfC"};